import { Pipe, PipeTransform } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Pipe({
  name: 'errorMessages',
  standalone: true,
  pure: true,
})
export class ErrorMessagesPipe implements PipeTransform {
  transform(errors: ValidationErrors | null | undefined): string[] {
    if (errors) {
      return Object.values(errors)
        .filter(e => e?.message)
        .map(e => e.message);
    }

    return [];
  }
}
